import Bet from '../Bet';
import _ from 'underscore';
import utils from '../../../race-schedule/util';

class SingleLegBet extends Bet {

	static positions () {
		return 0;
	}

	static selectors () {
		return _.map(_.range(1, this.positions() + 1), function (item) {
			return {
				key: item,
				label: item + utils.ordinal(item) + ' Place'
			};
		});
	}

	// From: http://stackoverflow.com/questions/1112195/formula-for-calculating-exotic-wagers-such-as-trifecta-and-superfecta
	static getPermutations(permutations, groups, group, permSoFar, nextGroupIndex) {

		var nextPermSoFar;
		var self = this;
		_.each(group, function (number) {

			nextPermSoFar = _.clone(permSoFar);

			// Only proceed if num isn't a repeat in nextPermSoFar
			if (_.indexOf(nextPermSoFar, number) === -1) {
				nextPermSoFar.push(number); // Add this number to the clone.
				if (nextGroupIndex !== groups.length) {
					self.getPermutations(permutations, groups, groups[nextGroupIndex], nextPermSoFar, nextGroupIndex + 1);
				} else {
					permutations.push(nextPermSoFar);
				}
			}

		});

	}

	static permutations (selections, box = false) {

		var permutations_arr = [];
		this.getPermutations(permutations_arr, selections, selections[0], [], 1);
		return permutations_arr.length;

	}

}

export default SingleLegBet;



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/gambling-calculator/bets/SingleLeg/SingleLegBet.js
 **/